import { Route, Routes } from "react-router-dom";
import Courses from "../pages/Dashboard/Courses";
import AdminLayout from "../components/Layout/AdminLayout";
import AdminProfile from "../pages/Dashboard/AdminProfile";
import Students from "../pages/Dashboard/Students";
import AssignCourse from "../pages/Dashboard/AssignCourse";
import UserProfile from "../pages/Dashboard/UserProfile";
import Reviews from "../pages/Dashboard/Reviews";
import StudentsRequests from "../pages/Dashboard/StudentsRequests";
import StudentProgress from "../pages/Dashboard/StudentProgress";
import Coupons from "../pages/Dashboard/Coupouns";
import Packages from "../pages/Dashboard/Packages";
import FreezeStudent from "../pages/Dashboard/FreezeStudent";
import SupportCenter from "../pages/Dashboard/SupportCenter";
import Books from "../pages/Dashboard/Books";
import BookRequests from "../pages/Dashboard/BookRequests";
import SkipCourseQuiz from "../pages/Dashboard/SkipCourseQuiz";
import TransactionDetails from "../pages/Dashboard/TransactionsDetails";
import Transactions from "../pages/Dashboard/Transactions";
const SalesRoutes = () => {
  return (
    <Routes>
      <Route element={<AdminLayout />}>
        <Route index path="/students" element={<Students />} />
        <Route path="/profile" element={<AdminProfile />} />
        <Route path="/students/:id" element={<UserProfile />} />
        <Route path="/courses" element={<Courses />} />
        <Route
          path="/courses/student-progress/:id"
          element={<StudentProgress />}
        />
        <Route path="/courses/freeze-student/:id" element={<FreezeStudent />} />
        <Route path="/books" element={<Books />} />
        <Route path="/books-requests" element={<BookRequests />} />
        <Route path="/reviews" element={<Reviews />} />
        <Route path="/requests" element={<StudentsRequests />} />
        <Route path="/support" element={<SupportCenter />} />
        <Route path="/assign-course" element={<AssignCourse />} />
        <Route path="/packages" element={<Packages />} />
        <Route path="/skip-quiz/:courseId" element={<SkipCourseQuiz />} />
        <Route path="/coupons" element={<Coupons />} />
        <Route path="/transactions" element={<Transactions />} />

        <Route path="/transactions/:id" element={<TransactionDetails />} />

      </Route>
    </Routes>
  );
};

export default SalesRoutes;
